import React, { useMemo } from 'react';
import styled from 'styled-components';
import { string, bool } from 'prop-types';
import { classnames } from '../utils/css';
import { randomColor } from '../utils/profileHelpers';

const Circle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 2.8em;
  height: 2.8em;
  padding-top: 1px;

  background-color: rgb(255, 255, 255);

  font-size: 2em;
  letter-spacing: -2px;
  padding-right: 2px; /* to compensate for the letter-spacing */
  color: ${({initialsColor}) => initialsColor || '#E6B952' };
  text-decoration: none;

  border-radius: 50%;
  border: 4px solid #66AFE9;

  margin-left: .8em;
  margin-right: .6em;
  margin-top: .3em;
  ${({ centered }) => centered && 'margin-bottom: .3em;'}


  @media(max-width: 720px) {
    font-size: 1.75em;
  }

  &.small {
    border-width: 2px;
    font-size: .75em;
    font-weight: 700;
    letter-spacing: -1px;
    padding-right: 1px;
  }

  &:before {
    content: attr(data-letters)
  }
`;


const InitialsCircle = ({ initials, initialsColor, small, centered }) => {
  const defaultColor = useMemo(() => randomColor());
  return <Circle
    className={classnames({ small })}
    data-qa-hook="initialsCircle"
    data-letters={initials}
    initialsColor={initialsColor ?? defaultColor}
    small={small}
    centered={centered}
  />;
};

export default InitialsCircle;

InitialsCircle.propTypes = {
  initials: string,
  initialsColor: string,
  small: bool,
  centered: bool
};
